var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomRightQuarterCircleOfGate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C32 4.2023 31.1723 8.36345 29.5641 12.2459C27.956 16.1283 25.5989 19.6559 22.6274 22.6274C19.6559 25.5989 16.1283 27.956 12.2459 29.5641C8.36345 31.1723 4.2023 32 -1.90735e-06 32L0 0H32Z",
    fill: "#005857"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRightQuarterCircleOfGate);
export default __webpack_public_path__ + "static/media/BottomRightQuarterCircleOfGate.8ce8957a.svg";
export { ForwardRef as ReactComponent };